import moment from 'moment'
export default {
  "entityName": "fullyused",
  upsert: 'full',
  filterStorage: {},
  "pagination": {
    "rowsPerPage": 10,
    "page": 1,
    "sortBy": "id",
    "descending": true
  },
  "fields": [
    {
      text: 'Insert Date',
      //issue 316 - modifica date da-a , aggiunto placeholderx
      filtertofrom: true,
      'type': 'date', //issue 257 services cambiato datetime con date
      //'type': 'date',
      //issue 316 - modifica date da-a , aggiunto placeholderx
      value: 'request_date',
      render: item => moment(item.request_date).format('YYYY-MM-DD'),
      table: { filter: true, sortable: true },
      mini: true,
      readonly: true,
    },
    {
      text: 'Confirmed Date',
      value: 'status_confirmed_date',
      render: item => item.status_confirmed_date ? moment(item.status_confirmed_date).format('YYYY-MM-DD'):null,
      filtertofrom: true,
      'type': 'datetime',
      readonly: (item,state)=> !(state.user.role === 'Administrator' || state.user.role === 'EMN User'),
      visible: (item,state)=> (state.user.role === 'Administrator' || state.user.role === 'EMN User') && item.status === 'CONFIRMED',
      validators: [
        (field, value, item) => {
          if (!item.canceling && !value) {
            return 'Confirmed Date is required'
          }
          return true
        },
    ]
    },
    {
      "value": "protocol_id",
      "text": "Protocol",
      "type": "autocomplete",
      small: true,
      visible: false,
      readonly: true,
      "table": {
        "sortable": true,
        filter: true
      },
      "title": "name",
      "subtitle": "name",
      "filter": null
    },
    {
      "value": "site.name",
      "text": "Site",
      render: ({ site }) => site && `${site.city} - ${site.name}`,
      filter: (item, search) => {
        if (search) return [{ 'site.name': `%${search}%` }, { 'site.city': `%${search}%` }, { 'site.code': `%${search}%` }]
      },
      readonly: true,
      "table": {
        sortable: true,
        filter: true
      },
      visible: (item, state) => state.user.role === 'Administrator' || state.user.role === 'EMN User',
    },
    {
      text: 'Labels',
      value: 'labels',
      type: 'check',
      visible: false,
      table: true
    },
    {
      value: 'pdf',
      text: 'Secondary labelling statement',
      type: 'file',
      hint: 'Attach secondary labelling statement, if lost or destroyed, attach the PI statement',
      visible: item => item.labels && item.status !== 'CONFIRMED',
      validators: ['required']
    },
    {
      value: 'status',
      text: 'Status',
      type: 'list',
      list: ['INIT', 'CONFIRMED'],
      table: {
        sortable: true,
        filter: true
      },
      visible: false
    },
		{
			value: 'fullyused_drugs.name',
			text: 'Drugs',
			id: 'id',
			filter: (item, search) => search && [{ 'fullyused_drugs.name': `%${search}%` }],
			subtitle: item => `${item.dose}${item.measure_unit} - ${item.protocol.name}`,
			type: 'autocomplete',
			table: {
					filter: true,
			},
      //old render before 27-03-2026
			// render: item => 
			// 		item.fullyused_drugs && item.fullyused_drugs.reduce((drugs, drug, idx) => drugs + `${drug.name}(${drug.dose + drug.measure_unit}, ${item.drugs[idx] && (item.drugs[idx].n_pieces)}) ` , ''),
      render: item => 
					{ 
            return item.fullyused_drugs.reduce((drugs, drug) => { 
              let n_pieces=0
              item.drugs.forEach(element => {
                if(drug.id===element.drug_id){
                  n_pieces+=element.n_pieces
              }
              });
              return drugs + `${drug.name}(${drug.dose + drug.measure_unit}, ${n_pieces}) `
            } , '') 
          },
			visible: false
		}    
  ],
  "actions": [
    "upsert", "audit"
  ]
}
